"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Restore = void 0;
const react_1 = __importDefault(require("react"));
const components_1 = require("@veeam/components");
const restoreConfiguration16_svg_1 = __importDefault(require("../../../../assets/icons/restoreConfiguration16.svg"));
const restorePoint_svg_1 = __importDefault(require("../../../../assets/icons/restorePoint.svg"));
const core_1 = require("../../../../core");
require("./types");
exports.Restore = react_1.default.memo(({ isDisabled, onRestoreConfiguration, onAvailableRestorePoint }) => {
    const { t } = core_1.useFeatureContext();
    return (react_1.default.createElement(components_1.StackView, { direction: components_1.STACK_DIRECTION.column, gap: components_1.STACK_GAP.s },
        react_1.default.createElement(components_1.TitleH2, null, t('configurationBackup|restore|header')),
        react_1.default.createElement(components_1.Paragraph, null, t('configurationBackup|restore|description')),
        react_1.default.createElement(components_1.StackView, { direction: components_1.STACK_DIRECTION.row, gap: components_1.STACK_GAP.xl },
            react_1.default.createElement(components_1.LinkButton, { iconBefore: restoreConfiguration16_svg_1.default, disabled: isDisabled, onClick: () => {
                    onRestoreConfiguration();
                } }, t('configurationBackup|restore|actions|restore|label')),
            react_1.default.createElement(components_1.LinkButton, { iconBefore: restorePoint_svg_1.default, disabled: isDisabled, onClick: () => {
                    onAvailableRestorePoint();
                } }, t('configurationBackup|restore|actions|restorePoints|label')))));
});
//# sourceMappingURL=Restore.js.map